var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Light-S"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.10146 12.5619C3.76867 12.5619 3.52937 12.3226 3.52937 12.0182C3.52937 11.7093 3.76867 11.47 4.10146 11.47H11.5349C11.8557 11.47 12.1033 11.7093 12.1033 12.0182C12.1033 12.3226 11.8557 12.5619 11.5349 12.5619H4.10146ZM4.10146 16.0674C3.76867 16.0674 3.52937 15.8281 3.52937 15.5192C3.52937 15.2148 3.76867 14.971 4.10146 14.971H11.5349C11.8557 14.971 12.1033 15.2148 12.1033 15.5192C12.1033 15.8281 11.8557 16.0674 11.5349 16.0674H4.10146ZM2.81218 20H12.7818C14.6547 20 15.6022 19.0405 15.6022 17.1548V8.501H8.87176C7.72814 8.501 7.17921 7.94834 7.17921 6.8047V0H2.81218C0.950416 0 0 0.959508 0 2.84517V17.1548C0 19.0487 0.943006 20 2.81218 20ZM8.90507 7.31855H15.4799C15.4313 6.96186 15.1735 6.62906 14.783 6.23033L9.44984 0.822897C9.06388 0.42869 8.71091 0.170043 8.36164 0.109514V6.77139C8.36164 7.1411 8.54731 7.31855 8.90507 7.31855Z",
    fill: "#1F2647"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.d9600964d7b4b1a4c03f49352536f277.svg";
export { ForwardRef as ReactComponent };